/* eslint-disable no-template-curly-in-string */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-template */
/* eslint-disable no-var */
import Cookies from 'js-cookie';

import { isBrowserSupported, __ } from './utils';

//
// Using ECMAScript 5 to maximize the support
//

var CONTAINER_ID = 'outdated-browser-container';
var COOKIE_NAME = 'outdated_browser_hidden';
var COOKIE_DURATION = 1 * 3600 * 1000; // 1h

var OutdatedBrowser = {
  container: null,

  init: function () {
    var isHidden = Boolean(Cookies.get(COOKIE_NAME));

    if (isBrowserSupported() || isHidden) {
      return;
    }

    this.render();
    this.bindEvents();
  },

  render: function () {
    var templateVariables = this._getTemplateVariables();
    var container = document.createElement('div');

    container.id = CONTAINER_ID;
    container.setAttribute('data-testid', CONTAINER_ID);
    container.innerHTML = this._template.replace(
      // replace strings ${varName} with it's value
      /\$\{(\w+)}/g,
      function (_, varName) {
        return templateVariables[varName] || '';
      },
    );

    this.container = container;

    document.body.appendChild(container);
  },

  bindEvents: function () {
    var self = this;
    var closeButton = this.container.querySelector('div[role="button"]');

    var onClose = function () {
      Cookies.set(COOKIE_NAME, '1', {
        expires: new Date(new Date().getTime() + COOKIE_DURATION),
      });
      self.destroy();
    };
    var onKeyDown = function (event) {
      // "Enter" or "Space"
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        onClose();
      }
    };

    if (closeButton) {
      closeButton.addEventListener('click', onClose);
      closeButton.addEventListener('keydown', onKeyDown);
    }
  },

  destroy: function () {
    if (this.container) {
      this.container.parentElement.removeChild(this.container);
      this.container = null;
    }
  },

  _template:
    // Notes on styling:
    // 1. Z-index is set to be above general loading screen that uses CSS class
    // `.on-top` defined in app/assets/legacy/stylesheets/helpers/display.scss:105
    // 2. Background color is the "fire" from the standard theme.
    // 3. Font is "body", "semibold".

    /* */ '<div style="position: fixed; z-index: 1060; left: 0; right: 0; top: 0; display: flex; align-items: center; justify-content: space-between; padding:0 24px; background: rgb(253, 67, 41);">' +
    /* .. */ '<div style="padding: 16px 0; display: flex; color: white;">' +
    /* .... */ '${iconWarning}' +
    /* .... */ '<div style="margin: 0 12px; color: white; font-size: 1.0769230769230769rem; font-weight: 600;">${message}</div>' +
    /* .. */ '</div>' +
    /* .. */ '<div aria-label="${closeButtonMessage}" role="button" tabindex="0" style="color: white; height: 28px; padding: 4px; margin-right: -4px; cursor: pointer;">${iconClose}</div>' +
    /* */ '</div>',

  _getTemplateVariables: function () {
    // Must be initialized when translations are ready
    return {
      message: __(
        'Your browser is outdated and may impact your experience on this site. Consider updating your browser.',
      ),
      closeButtonMessage: __('Hide outdated browser message'),
      iconWarning:
        '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="triangle-exclamation" class="svg-inline--fa fa-triangle-exclamation sc-gJhJTp cTskJk" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height: 16px;"><path fill="currentColor" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path></svg>',
      iconClose:
        '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" class="svg-inline--fa fa-xmark sc-gJhJTp cTskJk" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="height: 20px;"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path></svg>',
    };
  },
};

export default OutdatedBrowser;
